var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-radio-group"},_vm._l((_vm.items),function(item){return _c('el-radio',{key:item.id,attrs:{"label":item.id},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }